export default {
  computed: {
    originalMeasurements () {
      const fieldData = this.$store.state.fieldRecordSystem.data.field
      const {fieldId} = this.$store.state.fieldRecordSystem.navigation.location
      return fieldData[fieldId].nutrients
    }
  }
}
